import React from "react";
import DocTypeVideo from "@components/IComDocType/DocTypes/DocTypeVideo";
import DocTypeScriptAndHtmlInjection from "@components/IComDocType/DocTypes/DocTypeScriptAndHtmlInjection";
import DocTypeImages from "@components/IComDocType/DocTypes/DocTypeImages";
import DocTypeInnerGrid from "@components/IComDocType/DocTypes/DocTypeInnerGrid";
import DocTypeYotpoReviewCarousel from "@components/IComDocType/DocTypes/DocTypeYotpoReviewCarousel";
import DocTypeCountdown from "@components/IComDocType/DocTypes/DocTypeCountdown";
import DocTypeResellerApplication from "@components/IComDocType/DocTypes/DocTypeResellerApplication";
import DocTypeContactForm from "@components/IComDocType/DocTypes/DocTypeContactForm";
import DocTypeMall from "@components/IComDocType/DocTypes/DocTypeMall";
import DocTypeTicker from "@components/IComDocType/DocTypes/DocTypeTicker";
import DocTypeNewsletterSignup from "@components/IComDocType/DocTypes/DocTypeNewsletterSignup";

export default class IComDocType extends React.Component {

    constructor(props) {
        super(props);
        this.components = { 
            video: DocTypeVideo,
            scriptAndHtmlInjection: DocTypeScriptAndHtmlInjection,
            imageGallery: DocTypeImages,
            innerGrid: DocTypeInnerGrid,
            yotpoReviewCarousel: DocTypeYotpoReviewCarousel,
            countdown: DocTypeCountdown,
            resellerApplication: DocTypeResellerApplication,
            mall: DocTypeMall,
            berikssonContactForm: DocTypeContactForm,
            ticker: DocTypeTicker,
            newsletterSignup: DocTypeNewsletterSignup
        }
    }

    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    render() {
        //console.debug("GridBaseEditor - RENDER")
        // Figure out view

        const serverRender = typeof window === 'undefined';

        const { model } = this.props;
        const viewName = model.value.dtgeContentTypeAlias;//control.editor.render != null ? control.editor.render : control.editor.view;
        const View = this.components[viewName];
        if (!View) {
            //!serverRender && console.debug("Missing editor:", viewName);
            return ""; // No editor
        }


        //if (serverRender) {
        //    return (<View {...this.props} model={control} />);
        //}

        return (
            <View {...this.props} model={model.value.value} />
        );

    }
}